import React from 'react'
import { ProgressBarContainer, Progress } from './styled'

export function ProgressBar(props){
    return (
        <ProgressBarContainer>
            <Progress width={props.width} />
        </ProgressBarContainer>
    )
}